(function () {
  'use strict';

  var currencyConfig = {
    INR: {
      symbol: "₹",
      rate: 1.0,
      decimals: 0,
      position: "before"
    },
    AFN: {
      symbol: "؋",
      rate: 0.82,
      decimals: 0,
      position: "after"
    },
    USD: {
      symbol: "$",
      rate: 0.012,
      decimals: 2,
      position: "before"
    },
    GBP: {
      symbol: "£",
      rate: 0.0093,
      decimals: 2,
      position: "before"
    },
    AED: {
      symbol: "د.إ",
      rate: 0.044,
      decimals: 2,
      position: "before"
    },
    SAR: {
      symbol: "﷼",
      rate: 0.045,
      decimals: 2,
      position: "before"
    },
    AUD: {
      symbol: "A$",
      rate: 0.018,
      decimals: 2,
      position: "before"
    },
    CAD: {
      symbol: "C$",
      rate: 0.016,
      decimals: 2,
      position: "before"
    },
    SGD: {
      symbol: "S$",
      rate: 0.016,
      decimals: 2,
      position: "before"
    },
    EUR: {
      symbol: "€",
      rate: 0.011,
      decimals: 2,
      position: "before"
    }
  };

  var countryToCurrency = {
    'AF': 'AFN', 'AX': 'EUR', 'AL': 'ALL', 'DZ': 'DZD', 'AD': 'EUR', 'AO': 'AOA', 'AI': 'XCD', 'AG': 'XCD', 
    'AR': 'ARS', 'AM': 'AMD', 'AW': 'AWG', 'AU': 'AUD', 'AT': 'EUR', 'AZ': 'AZN', 'BS': 'BSD', 'BH': 'BHD', 
    'BD': 'BDT', 'BB': 'BBD', 'BY': 'BYN', 'BE': 'EUR', 'BZ': 'BZD', 'BJ': 'XOF', 'BM': 'BMD', 'BT': 'BTN', 
    'BO': 'BOB', 'BA': 'BAM', 'BW': 'BWP', 'BR': 'BRL', 'IO': 'USD', 'VG': 'USD', 'BN': 'BND', 'BG': 'BGN', 
    'BF': 'XOF', 'BI': 'BIF', 'KH': 'KHR', 'CM': 'XAF', 'CA': 'CAD', 'CV': 'CVE', 'KY': 'KYD', 'CF': 'XAF', 
    'TD': 'XAF', 'CL': 'CLP', 'CN': 'CNY', 'CX': 'AUD', 'CC': 'AUD', 'CO': 'COP', 'KM': 'KMF', 'CG': 'XAF', 
    'CD': 'CDF', 'CK': 'NZD', 'CR': 'CRC', 'CI': 'XOF', 'HR': 'EUR', 'CW': 'ANG', 'CY': 'EUR', 'CZ': 'CZK', 
    'DK': 'DKK', 'DJ': 'DJF', 'DM': 'XCD', 'DO': 'DOP', 'EC': 'USD', 'EG': 'EGP', 'SV': 'USD', 'GQ': 'XAF', 
    'ER': 'ERN', 'EE': 'EUR', 'SZ': 'SZL', 'ET': 'ETB', 'FK': 'FKP', 'FO': 'DKK', 'FJ': 'FJD', 'FI': 'EUR', 
    'FR': 'EUR', 'GF': 'EUR', 'PF': 'XPF', 'TF': 'EUR', 'GA': 'XAF', 'GM': 'GMD', 'GE': 'GEL', 'DE': 'EUR', 
    'GH': 'GHS', 'GI': 'GIP', 'GR': 'EUR', 'GL': 'DKK', 'GD': 'XCD', 'GP': 'EUR', 'GT': 'GTQ', 'GG': 'GBP', 
    'GN': 'GNF', 'GW': 'XOF', 'GY': 'GYD', 'HT': 'HTG', 'HN': 'HNL', 'HK': 'HKD', 'HU': 'HUF', 'IS': 'ISK', 
    'IN': 'INR', 'ID': 'IDR', 'IQ': 'IQD', 'IE': 'EUR', 'IM': 'GBP', 'IL': 'ILS', 'IT': 'EUR', 'JM': 'JMD', 
    'JP': 'JPY', 'JE': 'GBP', 'JO': 'JOD', 'KZ': 'KZT', 'KE': 'KES', 'KI': 'AUD', 'XK': 'EUR', 'KW': 'KWD', 
    'KG': 'KGS', 'LA': 'LAK', 'LV': 'EUR', 'LB': 'LBP', 'LS': 'LSL', 'LR': 'LRD', 'LY': 'LYD', 'LI': 'CHF', 
    'LT': 'EUR', 'LU': 'EUR', 'MO': 'MOP', 'MG': 'MGA', 'MW': 'MWK', 'MY': 'MYR', 'MV': 'MVR', 'ML': 'XOF', 
    'MT': 'EUR', 'MQ': 'EUR', 'MR': 'MRU', 'MU': 'MUR', 'YT': 'EUR', 'MX': 'MXN', 'MD': 'MDL', 'MC': 'EUR', 
    'MN': 'MNT', 'ME': 'EUR', 'MS': 'XCD', 'MA': 'MAD', 'MZ': 'MZN', 'MM': 'MMK', 'NA': 'NAD', 'NR': 'AUD', 
    'NP': 'NPR', 'NL': 'EUR', 'NC': 'XPF', 'NZ': 'NZD', 'NI': 'NIO', 'NE': 'XOF', 'NG': 'NGN', 'NU': 'NZD', 
    'NF': 'AUD', 'MK': 'MKD', 'NO': 'NOK', 'OM': 'OMR', 'PK': 'PKR', 'PS': 'ILS', 'PA': 'PAB', 'PG': 'PGK', 
    'PY': 'PYG', 'PE': 'PEN', 'PH': 'PHP', 'PN': 'NZD', 'PL': 'PLN', 'PT': 'EUR', 'QA': 'QAR', 'RE': 'EUR', 
    'RO': 'RON', 'RU': 'RUB', 'RW': 'RWF', 'WS': 'WST', 'SM': 'EUR', 'ST': 'STN', 'SA': 'SAR', 'SN': 'XOF', 
    'RS': 'RSD', 'SC': 'SCR', 'SL': 'SLL', 'SG': 'SGD', 'SX': 'ANG', 'SK': 'EUR', 'SI': 'EUR', 'SB': 'SBD', 
    'SO': 'SOS', 'ZA': 'ZAR', 'GS': 'GBP', 'KR': 'KRW', 'SS': 'SSP', 'ES': 'EUR', 'LK': 'LKR', 'BL': 'EUR', 
    'SH': 'SHP', 'KN': 'XCD', 'LC': 'XCD', 'MF': 'EUR', 'PM': 'EUR', 'VC': 'XCD', 'SD': 'SDG', 'SR': 'SRD', 
    'SJ': 'NOK', 'SE': 'SEK', 'CH': 'CHF', 'TW': 'TWD', 'TJ': 'TJS', 'TZ': 'TZS', 'TH': 'THB', 'TL': 'USD', 
    'TG': 'XOF', 'TK': 'NZD', 'TO': 'TOP', 'TT': 'TTD', 'TA': 'GBP', 'TN': 'TND', 'TR': 'TRY', 'TM': 'TMT', 
    'TC': 'XCD', 'TV': 'AUD', 'UM': 'USD', 'UG': 'UGX', 'UA': 'UAH', 'AE': 'AED', 'GB': 'GBP', 'US': 'USD', 
    'UY': 'UYU', 'UZ': 'UZS', 'VU': 'VUV', 'VA': 'EUR', 'VE': 'VES', 'VN': 'VND', 'WF': 'XPF', 'EH': 'MAD', 
    'YE': 'YER', 'ZM': 'ZMW', 'ZW': 'ZWL'
  };

  var fallbackRates = {
    'USD': 0.012, 'EUR': 0.011, 'GBP': 0.0093, 'AUD': 0.018, 'CAD': 0.016, 'AED': 0.044,
    'SAR': 0.045, 'CNY': 0.086, 'JPY': 1.88, 'ALL': 1.13, 'AFN': 0.85, 'DZD': 1.61,
    'AMD': 4.65, 'ARS': 11.23, 'BDT': 1.32, 'BRL': 0.060, 'CLP': 11.23, 'INR': 1.0
  };

  var exchangeRates = { 'INR': 1.0 };
  var STORAGE_KEY_CURRENCY = 'lakshiv_selected_currency';
  var STORAGE_KEY_REGION = 'lakshiv_selected_region';
  var STORAGE_KEY_RATES = 'lakshiv_exchange_rates';
  var STORAGE_KEY_RATES_TIME = 'lakshiv_exchange_rates_time';

  // Read active country and currency from localStorage
  var activeCountry = localStorage.getItem('lakshiv_selected_country') || document.body.getAttribute('data-active-country') || 'IN';
  var activeCurrency = localStorage.getItem(STORAGE_KEY_CURRENCY) || getCurrencyFromCountryCode(activeCountry);
  var activeRegion = localStorage.getItem(STORAGE_KEY_REGION) || 'India';

  function getCurrencyFromCountryCode(cc) {
    if (!cc) return 'INR';
    return countryToCurrency[cc.toUpperCase()] || 'INR';
  }

  // Auto region detection (optional)
  function autoDetectRegion() {
    if (localStorage.getItem('lakshiv_selected_country')) return; // Don't override manual selection
    
    var tz = '';
    try {
      tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (e) {}
    
    var suggestedCountry = 'IN';
    var suggestedRegion = 'India';
    
    if (tz.indexOf('Kabul') !== -1) {
      suggestedCountry = 'AF';
      suggestedRegion = 'Afghanistan';
    } else if (tz.indexOf('London') !== -1 || tz.indexOf('Europe/London') !== -1) {
      suggestedCountry = 'GB';
      suggestedRegion = 'United Kingdom';
    } else if (tz.indexOf('Dubai') !== -1 || tz.indexOf('Asia/Dubai') !== -1) {
      suggestedCountry = 'AE';
      suggestedRegion = 'United Arab Emirates';
    } else if (tz.indexOf('Riyadh') !== -1) {
      suggestedCountry = 'SA';
      suggestedRegion = 'Saudi Arabia';
    } else if (tz.indexOf('Australia') !== -1) {
      suggestedCountry = 'AU';
      suggestedRegion = 'Australia';
    } else if (tz.indexOf('Canada') !== -1) {
      suggestedCountry = 'CA';
      suggestedRegion = 'Canada';
    } else if (tz.indexOf('Singapore') !== -1) {
      suggestedCountry = 'SG';
      suggestedRegion = 'Singapore';
    } else if (tz.indexOf('Europe') !== -1) {
      suggestedCountry = 'EU'; // Default European region code
      suggestedRegion = 'Europe';
    } else if (tz.indexOf('America') !== -1) {
      suggestedCountry = 'US';
      suggestedRegion = 'United States';
    }

    if (suggestedCountry !== 'IN') {
      var suggestedCurrency = getCurrencyFromCountryCode(suggestedCountry);
      console.log('[Currency] Auto-detected suggested region: ' + suggestedRegion);
      updateCurrencySelection(suggestedCountry, suggestedCurrency, suggestedRegion);
    }
  }

  // Load exchange rates and cache them
  function initExchangeRates() {
    var cachedRates = localStorage.getItem(STORAGE_KEY_RATES);
    var cachedTime = localStorage.getItem(STORAGE_KEY_RATES_TIME);
    var now = Date.now();
    
    // Cache for 12 hours
    if (cachedRates && cachedTime && (now - parseInt(cachedTime, 10) < 43200000)) {
      try {
        var rates = JSON.parse(cachedRates);
        applyLoadedRates(rates);
        return;
      } catch (e) {}
    }

    fetch('https://open.er-api.com/v6/latest/INR')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.rates) {
          localStorage.setItem(STORAGE_KEY_RATES, JSON.stringify(data.rates));
          localStorage.setItem(STORAGE_KEY_RATES_TIME, now.toString());
          applyLoadedRates(data.rates);
        } else {
          useFallbackRates();
        }
      })
      .catch(function () {
        useFallbackRates();
      });
  }

  function applyLoadedRates(rates) {
    exchangeRates = rates;
    console.log('[Currency] Loaded live exchange rates from cache/API.');
    convertAllPrices();
  }

  function useFallbackRates() {
    exchangeRates = fallbackRates;
    console.log('[Currency] Failed to fetch live rates, using fallback values.');
    convertAllPrices();
  }

  // Formatting function
  function formatValue(value, currencyCode) {
    var conf = currencyConfig[currencyCode];
    if (conf) {
      var formatted = value.toLocaleString('en-US', {
        minimumFractionDigits: conf.decimals,
        maximumFractionDigits: conf.decimals
      });
      if (conf.position === 'before') {
        return conf.symbol + formatted;
      } else {
        return formatted + ' ' + conf.symbol;
      }
    } else {
      // Fallback dynamic browser formatting for any other currency
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currencyCode
        }).format(value);
      } catch (e) {
        return currencyCode + ' ' + value.toFixed(2);
      }
    }
  }

  // Convert a single price element
  function convertElement(el) {
    if (el.getAttribute('data-currency-converted') === activeCurrency) return;

    var rate = exchangeRates[activeCurrency] || fallbackRates[activeCurrency];
    if (activeCurrency !== 'INR' && !rate) return; // Wait for exchange rates to load
    
    var rawValue = el.getAttribute('data-base-price');
    if (!rawValue) return;

    var basePriceInr = parseFloat(rawValue) / 100;
    if (isNaN(basePriceInr)) return;

    var actualRate = rate || 1;
    var converted = basePriceInr * actualRate;
    
    el.textContent = formatValue(converted, activeCurrency);
    el.setAttribute('data-currency-converted', activeCurrency);
  }

  // Convert all annotated elements on the page
  function convertAllPrices() {
    var els = document.querySelectorAll('[data-base-price]');
    els.forEach(convertElement);
    convertBundlerPrices();
  }

  // Parse and convert native Bundler App widget prices dynamically
  function convertBundlerPrices() {
    var activeCountryCode = localStorage.getItem('lakshiv_selected_country') || document.body.getAttribute('data-active-country') || 'IN';
    var activeCurrency = getCurrencyFromCountryCode(activeCountryCode);

    var rate = exchangeRates[activeCurrency] || fallbackRates[activeCurrency];
    if (activeCurrency !== 'INR' && !rate) return; // Wait for exchange rates to load

    var actualRate = rate || 1;

    var bundlerContainers = document.querySelectorAll('.bundler-target-element *, [class*="bndlr-"] *, [class*="bundler-"] *, [id*="bndlr-"] *, [id*="bundler-"] *');
    bundlerContainers.forEach(function (el) {
      if (el.children.length > 0) return; // leaf elements only
      if (el.getAttribute('data-currency-converted') === activeCurrency) return;

      var text = el.textContent;
      if (!text) return;

      // Match patterns like ₹259.00 or Rs. 259.00
      var priceRegex = /(?:₹|Rs\.?\s*)[\d.,]+/g;
      var matches = text.match(priceRegex);
      if (!matches) return;

      var originalText = el.getAttribute('data-original-text');
      if (!originalText) {
        originalText = text;
        el.setAttribute('data-original-text', originalText);
      }

      var newText = originalText;
      var originalMatches = originalText.match(priceRegex);
      if (originalMatches) {
        originalMatches.forEach(function (matchStr) {
          var numMatch = matchStr.match(/[\d.,]+/);
          if (numMatch) {
            var clean = numMatch[0].replace(/,/g, '');
            var parsed = parseFloat(clean);
            if (!isNaN(parsed) && parsed > 0) {
              var converted = parsed * actualRate;
              var formatted = formatValue(converted, activeCurrency);
              newText = newText.replace(matchStr, formatted);
            }
          }
        });
      }

      el.textContent = newText;
      el.setAttribute('data-currency-converted', activeCurrency);
    });
  }

  // Update selection and convert
  function updateCurrencySelection(countryCode, currencyCode, regionName) {
    activeCountry = countryCode;
    activeCurrency = currencyCode;
    activeRegion = regionName;
    localStorage.setItem('lakshiv_selected_country', countryCode.toUpperCase());
    localStorage.setItem(STORAGE_KEY_CURRENCY, currencyCode);
    localStorage.setItem(STORAGE_KEY_REGION, regionName);
    
    document.documentElement.setAttribute('data-selected-currency', currencyCode);
    
    updateSelectorLabels();
    convertAllPrices();
  }

  // Dynamic selector labels re-writing
  function updateSelectorLabels() {
    var countryItems = document.querySelectorAll('.announcement__dropdown-item, .localization-select-wrapper select option, .localization-select option');
    countryItems.forEach(function (el) {
      var countryCode = el.getAttribute('value') || el.value;
      if (countryCode) {
        var cc = countryCode.toUpperCase();
        var mappedCurrency = getCurrencyFromCountryCode(cc);
        if (mappedCurrency) {
          var html = el.innerHTML;
          if (html.indexOf('(INR)') !== -1) {
            el.innerHTML = html.replace('(INR)', '(' + mappedCurrency + ')');
          } else {
            var text = el.textContent;
            if (text.indexOf('(INR)') !== -1) {
              el.textContent = text.replace('(INR)', '(' + mappedCurrency + ')');
            }
          }
        }
      }
    });

    // Update active dropdown triggers flags and text
    var triggers = document.querySelectorAll('.announcement__dropdown-trigger');
    triggers.forEach(function (el) {
      var activeCountryCode = localStorage.getItem('lakshiv_selected_country') || document.body.getAttribute('data-active-country') || 'IN';
      activeCountryCode = activeCountryCode.toUpperCase();
      
      var matchingItem = document.querySelector('.announcement__dropdown-item[value="' + activeCountryCode + '"]');
      if (matchingItem) {
        var triggerImg = el.querySelector('img.country-flag');
        var matchingImg = matchingItem.querySelector('img.country-flag');
        if (triggerImg && matchingImg) {
          triggerImg.src = matchingImg.src;
          if (matchingImg.srcset) triggerImg.srcset = matchingImg.srcset;
        }

        var triggerSpan = el.querySelector('span');
        var matchingSpan = matchingItem.querySelector('span');
        if (triggerSpan && matchingSpan) {
          var countryName = matchingSpan.textContent.split('(')[0].trim();
          var mappedCurrency = getCurrencyFromCountryCode(activeCountryCode);
          triggerSpan.textContent = countryName + ' (' + mappedCurrency + ')';
        }
      }
    });

    // Update cart warning region codes
    document.querySelectorAll('[data-warning-region-code]').forEach(function (el) {
      el.textContent = activeCurrency;
    });
  }

  // Intercept click & change events on country selectors
  function bindSelectorInterceptions() {
    document.addEventListener('click', function (event) {
      var item = event.target.closest('.announcement__dropdown-item');
      if (item) {
        event.preventDefault();
        event.stopPropagation();
        var countryCode = item.getAttribute('value') || item.value;
        if (countryCode) {
          var cc = countryCode.toUpperCase();
          var currency = getCurrencyFromCountryCode(cc);
          var regionName = item.textContent.split('(')[0].trim();
          updateCurrencySelection(cc, currency, regionName);
          
          var dropdown = item.closest('[data-dropdown]');
          if (dropdown) {
            dropdown.classList.remove('is-open');
          }
        }
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.name === 'country_code') {
        var countryCode = event.target.value;
        if (countryCode) {
          event.preventDefault();
          event.stopPropagation();
          var cc = countryCode.toUpperCase();
          var currency = getCurrencyFromCountryCode(cc);
          var option = event.target.querySelector('option[value="' + countryCode + '"]');
          var regionName = option ? option.textContent.split('(')[0].trim() : 'International';
          updateCurrencySelection(cc, currency, regionName);
        }
      }
    });

    // Filter region/country items based on search input
    document.addEventListener('input', function (event) {
      var searchInput = event.target.closest('[data-dropdown-search]');
      if (searchInput) {
        var query = searchInput.value.toLowerCase().trim();
        var menu = searchInput.closest('[data-dropdown-menu]');
        if (menu) {
          var items = menu.querySelectorAll('.announcement__dropdown-item');
          items.forEach(function (item) {
            var text = item.textContent.toLowerCase();
            if (text.indexOf(query) !== -1) {
              item.style.display = '';
            } else {
              item.style.display = 'none';
            }
          });
        }
      }
    });
  }

  // Handle theme toggling (Light / Dark Mode)
  function initThemeToggle() {
    var toggles = document.querySelectorAll('[data-theme-toggle]');

    function syncThemeToggle(isDark) {
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-pressed', isDark ? 'true' : 'false');
        toggle.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to night mode');
      });
      var themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (themeColorMeta) themeColorMeta.setAttribute('content', isDark ? '#24161D' : '#FFF9F7');
    }

    syncThemeToggle(document.documentElement.classList.contains('dark'));

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isDark = document.documentElement.classList.toggle('dark');
        localStorage.setItem('lakshiv_theme', isDark ? 'dark' : 'light');
        syncThemeToggle(isDark);
      });
    });
  }

  // Initialization
  function init() {
    document.documentElement.setAttribute('data-selected-currency', activeCurrency);

    autoDetectRegion();
    initExchangeRates();
    bindSelectorInterceptions();
    updateSelectorLabels();
    initThemeToggle();

    // Periodically scan and convert Bundler prices during the first 6 seconds
    var bundlerInterval = setInterval(convertBundlerPrices, 400);
    setTimeout(function () {
      clearInterval(bundlerInterval);
    }, 6000);

    var observer = new MutationObserver(function (mutations) {
      var shouldConvert = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldConvert = true;
        } else if (mutation.type === 'characterData') {
          shouldConvert = true;
        }
      });
      if (shouldConvert) {
        convertAllPrices();
      }
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
